import clsx from 'clsx';

import { useRouter } from 'next/router';

import { Layout } from 'components/layout';
import { CardsMedium } from 'components/slider/cards/medium';
import { HeaderCollection } from './header';

import { CustomMetadata } from 'components/metadata';

import { BreadcrumbsProps, allCasinos } from 'constants/routes-breadcrumbs';

import { LoadMoreButton } from 'components/load-more-button';
import { allMetadata } from 'constants/metadata';
import { useCasinosPagination } from 'hooks';

import { Routes } from 'constants/routes';
import { ICasino, ICasinoCollection } from 'constants/types';

import { FAQComponent } from 'components/casino-faq';
import { allFAQ } from 'constants/faq';
import { getCollectionIdentifier } from 'utils/slug';
import { CollectionDescription } from './description';
import styles from './styles.module.css';

export type Props = {
  casinos: ICasino[];
  casinosCount: number;
  collection: ICasinoCollection;
};

export const CollectionCasinoIdPage = ({
  collection,
  casinos,
  casinosCount,
}: Props) => {
  const router = useRouter();
  const { name } = router?.query;

  let formattedName = '';

  if (name) {
    if (typeof name === 'string') {
      const words = name.split('-');
      formattedName = words
        .map((word) => {
          return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(' ');
    }
  }

  const {
    page,
    isLast,
    setPage,
    isFetching,
    data: casinosPagination = [],
  } = useCasinosPagination({
    collection: getCollectionIdentifier(collection),
    initialData: casinos,
    initialCount: casinosCount,
  });

  const data = casinosPagination?.length ? casinosPagination : casinos;

  return (
    <div className={styles.container}>
      <CustomMetadata
        metadata={
          (allMetadata[name as keyof typeof allMetadata] as any) ??
          (allMetadata.casinoCollection(collection) as any)
        }
      />

      <Layout hasFooter isSearchInputMobileVisible>
        <main className={clsx(styles.main, styles.main_collection)}>
          <HeaderCollection
            items={[
              ...allCasinos,
              {
                id: 2,
                title: collection?.name ?? '',
                path: Routes.allCasinos,
              } as BreadcrumbsProps,
            ]}
          />
          <CardsMedium
            data={data}
            guides={collection.posts}
            description={collection.description}
            title={`${formattedName}`}
          />
          {data?.length > 0 && !isLast && (
            <>
              <LoadMoreButton
                isFetching={isFetching}
                isAuto={false}
                onClick={() => setPage(page + 1)}
              />
              <div className={styles.bottom} />
            </>
          )}

          <CollectionDescription name={name as string} />

          <FAQComponent
            customFaq={allFAQ[name as keyof typeof allFAQ]}
            titleClassName={styles.faq_title}
          />
        </main>
      </Layout>
    </div>
  );
};
